/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Analysis_ActionInputs */

const en_us2_workout_share_analysis_action = /** @type {(inputs: Workout_Share_Analysis_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask your trainer for a review`)
};

const pt_br2_workout_share_analysis_action = /** @type {(inputs: Workout_Share_Analysis_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir análise ao personal`)
};

const es_419_workout_share_analysis_action = /** @type {(inputs: Workout_Share_Analysis_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir un análisis al entrenador`)
};

const pt_pt2_workout_share_analysis_action = /** @type {(inputs: Workout_Share_Analysis_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir análise ao treinador`)
};

const fr_fr2_workout_share_analysis_action = /** @type {(inputs: Workout_Share_Analysis_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander une analyse au coach`)
};

const de_de2_workout_share_analysis_action = /** @type {(inputs: Workout_Share_Analysis_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach um Analyse bitten`)
};

const it_it2_workout_share_analysis_action = /** @type {(inputs: Workout_Share_Analysis_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi un'analisi al coach`)
};

/**
* | output |
* | --- |
* | "Ask your trainer for a review" |
*
* @param {Workout_Share_Analysis_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_analysis_action = /** @type {((inputs?: Workout_Share_Analysis_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Analysis_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_analysis_action(inputs)
	if (locale === "es-419") return es_419_workout_share_analysis_action(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_analysis_action(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_analysis_action(inputs)
	if (locale === "de-DE") return de_de2_workout_share_analysis_action(inputs)
	if (locale === "it-IT") return it_it2_workout_share_analysis_action(inputs)
	return en_us2_workout_share_analysis_action(inputs)
});
export { workout_share_analysis_action as "workout-share.analysis_action" }